import React from 'react'
import LtsDropdownIdValue from './lts-dropdown-id-value'
import { enums } from '../../constants'

export default function LtsDropdownTipoStatusContrato(props) {
  const resolveValueFn = (data) => {
    if (data && data.id && data.value) {
      return data
    }
    return enums.TiposStatusContrato.find((v) => v.id === data)
  }

  return (
    <React.Fragment>
      <LtsDropdownIdValue
        name={props.name}
        label={props.label}
        value={props.value}
        onChange={props.onChange}
        options={enums.TiposStatusContrato}
        resolveValueFn={resolveValueFn}
        showOptionAll={props.showOptionAll}
      />
    </React.Fragment>
  )
}
